export function EmailFormat(value: string) {
  if (!value) return value;
  const email = value.trim();
  return email;
}
